/*
|-------------------------------------------------------------------------------
| Model Generator for Restful API
|-------------------------------------------------------------------------------
|
| Although this has configured a @rexlabs/model-generator for restful entity
| & value list endpoints, it can be used to generate models that *don't* do
| anything with an API.
|
*/

import _ from 'lodash';
import ReduxModelGenerator from '@rexlabs/model-generator';
import { api } from 'utils/api-client';

function getPathFromArgs(type, args) {
  return args.websiteId ? `/websites/${args.websiteId}/${type}` : `/${type}`;
}

const defaultConfig = {
  entities: {
    api: {
      createItem: (type, args) => api.post(getPathFromArgs(type, args), args),
      fetchList: (type, args) => api.get(getPathFromArgs(type, args), args),
      fetchItem: (type, args, id) =>
        api.get(`${getPathFromArgs(type, args)}/${id}`, args),
      updateItem: (type, args, id) =>
        api.patch(`${getPathFromArgs(type, args)}/${id}`, args),
      trashItem: (type, args, id) =>
        api.delete(`${getPathFromArgs(type, args)}/${id}`, args),
      deleteItem: (type, args, id) =>
        api.delete(`${getPathFromArgs(type, args)}/${id}`, args),
      bulkUpdateItems: (type, args) =>
        api.put(getPathFromArgs(type, args), args),
      bulkTrashItems: (type, args) =>
        api.delete(getPathFromArgs(type, args), args),
      bulkDeleteItems: (type, args) =>
        api.delete(getPathFromArgs(type, args), args)
    }
  },
  valueLists: {
    api: {
      fetch: (type) => api.get(`lists/${type}`)
    }
  }
};

export default class RestAPIModelGenerator extends ReduxModelGenerator {
  constructor(type, config = {}) {
    super(type, _.merge({}, defaultConfig, config));
  }
}
